import Joi from 'joi';
import { email } from './common-schema';

export const signupSchema = Joi.object({
    email,
    firstName: Joi.string().required().messages({
        'string.empty': 'First name is required',
    }),
    lastName: Joi.string().required().messages({
        'string.empty': 'Last name is required',
    }),
    smsPhoneNumber: Joi.string()
        .allow('')
        .pattern(/^((\+)?(\d{2}[-]))?(\d{10}){1}?$/)
        .messages({
            'string.pattern.base': 'Mobile number is invalid',
        }),
});
